import { SVGProps } from 'react'

const SvgAddCard = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
    <path d='M4 12h16V8H4Zm15 10v-3h-3v-2h3v-3h2v3h3v2h-3v3ZM4 20q-.825 0-1.412-.587Q2 18.825 2 18V6q0-.825.588-1.412Q3.175 4 4 4h16q.825 0 1.413.588Q22 5.175 22 6v6h-3q-2.075 0-3.537 1.462Q14 14.925 14 17v3Z' />
  </svg>
)

export default SvgAddCard
